export default "__VITE_ASSET__f668beac__"